import { featureCollection } from "@turf/helpers";

export function WFStoGeoJson(str: string) {
   let dom = new DOMParser().parseFromString(str, "text/xml");
   let crs: string | null = null;
   let features = [
      ...dom.getElementsByTagName("gml:featureMember"),
      ...dom.getElementsByTagName("wfs:member")
   ].map((a) => {
      let fContent = a.firstElementChild;
      let geometry: { type: string, coordinates: number[][] | number[][][] | number[] } = { type: "", coordinates: [] };
      let properties = {}
      if (fContent) {
         [...fContent.children].forEach(element => {
            if (element.firstElementChild?.getAttribute("srsName")) {
               let geomElement = element.firstElementChild;
               crs = geomElement.getAttribute("srsName") || "";
               let geom = GeometryToGeojson(geomElement);
               if (geom) {
                  geometry = geom as any;
               }
               return;
            }
            if (element.childNodes.length == 1) {
               let prop = element.tagName.split(":").at(-1)
               if (prop) {
                  properties = { ...properties, [prop]: element.textContent }
               }
            }
         });
         return {
            type: "Feature",
            id: "",
            geometry: geometry,
            properties: properties
         }
      }
   })
   let FC = featureCollection(features as any);
   if (crs) {
      FC["crs"] = crs;
   }
   let metadata = parseMetadata(dom);
   if (metadata) {
      FC["metadata"] = metadata;
   }
   return FC;
}

function GeometryToGeojson(elem: Element) {
   let type = elem.tagName.split(":").at(-1);
   switch (type) {
      case "Polygon":
         return PolygonToGeojson(elem, parseInt(elem.getAttribute("srsDimension") || "2"));
      case "Point":
         return PointToGeojson(elem, parseInt(elem.getAttribute("srsDimension") || "2"));
      case "LineString":
         return LineStringToGeojson(elem, parseInt(elem.getAttribute("srsDimension") || "2"));
      case "MultiSurface":
         return SurfaceToGeojson(elem, parseInt(elem.getAttribute("srsDimension") || "2"));
      case "MultiCurve":
         return CurveToGeojson(elem, parseInt(elem.getAttribute("srsDimension") || "2"));
   }
}

function CurveToGeojson(elem: Element, srsDimension?: number) {
   let name = elem.tagName;
   if (name.endsWith("Curve")) {
      let lineStrings = [...elem.getElementsByTagName("gml:LineString")].map((lineString) => {
         return LineStringToGeojson(lineString, srsDimension);
      });
      return {
         type: "MultiLineString",
         coordinates: lineStrings.filter((a) => a).map(p => p!.coordinates as number[][])
      };
   }
}

function SurfaceToGeojson(elem: Element, srsDimension?: number) {
   let name = elem.tagName;
   if (name.endsWith("Surface")) {
      let polygons = [...elem.getElementsByTagName("gml:Polygon")].map((polygon) => {
         return PolygonToGeojson(polygon, srsDimension);
      });
      return {
         type: "MultiPolygon",
         coordinates: polygons.filter((a) => a).map(p => p!.coordinates as number[][][])
      }

   }
}

function PolygonToGeojson(elem: Element, srsDimension?: number) {
   let name = elem.tagName;
   if (!srsDimension) {
      srsDimension = parseInt(elem.getAttribute("srsDimension") || "2");
   }
   if (name.endsWith("Polygon")) {
      let posList = [...elem.getElementsByTagName("gml:posList")].map((a) => {
         let content = a.textContent;
         return parseXMLCoords(content || "", srsDimension);
      })
      return {
         type: "Polygon",
         coordinates: posList
      }
   }
}

function PointToGeojson(elem: Element, srsDimension?: number) {
   let name = elem.tagName;
   if (name.endsWith("Point")) {
      let coordinates = elem.getElementsByTagName("gml:pos")[0];
      let content = coordinates.textContent;
      let coords = parseXMLCoords(content || "", srsDimension || 2)[0];
      return {
         type: "Point",
         coordinates: coords
      }
   }
}



function LineStringToGeojson(elem: Element, srsDimension?: number) {
   let name = elem.tagName;
   if (!srsDimension) {
      srsDimension = parseInt(elem.getAttribute("srsDimension") || "2");
   }
   if (name.endsWith("LineString")) {
      let posList = elem.getElementsByTagName("gml:posList")[0];
      let content = posList.textContent;
      return {
         type: "LineString",
         coordinates: parseXMLCoords(content || "", srsDimension)
      }
   }
}

function parseXMLCoords(str: string, dimension: number): number[][] {
   let flat = str.split(" ");
   const dimNPair = (idx: number, dim: number) => {
      let path = idx * dim;
      return flat.slice(path, path + dim).map(v => parseFloat(v)).reverse();
   };
   return new Array(Math.floor(flat.length / dimension)).fill(0).map((a, idx) => dimNPair(idx, dimension));
}

function parseMetadata(elem: Element | Document) {
   let metaElem = elem.getElementsByTagName("wfs:FeatureCollection")[0];
   return {
      numberMatched: metaElem.getAttribute("numberMatched"),
      numberReturned: metaElem.getAttribute("numberReturned"),
      timeStamp: metaElem.getAttribute("timeStamp"),
   }
}
